var map = {
	"./bddf/translations.json": 1208,
	"./ca-ts/translations.json": 1209,
	"./ct-test/translations.json": 1210,
	"./sandbox/translations.json": 1211,
	"./sogeprom/translations.json": 1212,
	"./test/translations.json": 1213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1207;